<template>
    <div
        class="row mt-3"
        v-if="isInEditMode">
        <div class="col d-flex justify-content-end">
            <button
                @click="discardEditModeChanges"
                class="btn btn-primary mr-1 d-flex text-left">
                <Icon
                    type="button-arrow"
                    :height="16"
                    :width="9" />
                {{ $t('editMode.discardChanges') }}
            </button>
            <button
                @click="saveEditModeChanges"
                :disabled="!hasAnyValueChangeInEditMode || !isModelPortfolioAvailable"
                class="btn btn-primary d-flex text-left">
                <Icon
                    type="button-arrow"
                    :height="16"
                    :width="9" />
                {{ $t('editMode.saveChanges') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'EditModeButtons',
    computed: {
        ...mapGetters([
            'isInEditMode',
            'hasAnyValueChangeInEditMode',
            'isModelPortfolioAvailable',
        ]),
    },
    methods: {
        ...mapActions([
            'discardEditModeChanges',
            'saveEditModeChanges',
        ]),
    },
};
</script>
